
  export default {
    name: 'BlogRecommendedSection',
    props: {
      data: {
        type: Array,
        default: ()=>[]
      },
    },
    data() {
      return {
        strapiData: []
      }
    },
    computed: {
    },
    methods: {
    },
  }
